/* 🤖 this file was generated by svg-to-ts */
export const sbIconsPlus: {
  name: 'plus';
  data: string;
} = {
  name: 'plus',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><path fill="currentColor" d="M13.125 6.125h-5.25V.875A.87502.87502 0 0 0 6.38128.25628.875.875 0 0 0 6.125.875v5.25H.875a.87502.87502 0 0 0-.61872 1.49372A.875.875 0 0 0 .875 7.875h5.25v5.25A.87502.87502 0 0 0 7 14a.875.875 0 0 0 .875-.875v-5.25h5.25A.87502.87502 0 0 0 14 7a.875.875 0 0 0-.875-.875"/></svg>`
};
